module.exports = __webpack_public_path__ + "static/media/timer-collect-backing.c3b8433c.png";